import styled from 'styled-components';
import ListItemCompoment from '@prisjakt/ui-list-item';
import StoreLogoComponent from '@prisjakt/ui-store-logo';
import OpenInNewIcon from 'mdi-react/OpenInNewIcon';

export const StyledListItem = styled(ListItemCompoment)({
  '&&': {
    img: {
      marginRight: '10px',
    },
  },
});
export const StoreLogo = styled(StoreLogoComponent)`
  height: 24px;
  img {
    height: 16px;
    width: auto;
  }
`;

export const OutlinkCallToAction = styled.span`
  color: ${p => p.theme.colors.maybeBlue700};

  .pj-ui-product-list-item--grid:hover &,
  .pj-ui-product-row:hover & {
    color: ${p => p.theme.colors.maybeBlue500};
  }
`;

export const OutlinkIcon = styled(OpenInNewIcon)`
  margin-left: 5px;
  vertical-align: -2px;
  path {
    fill: currentColor;
  }
`;
